import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { ErrorCircleRegular, WarningRegular } from "@fluentui/react-icons";
import * as React from "react";
import {
  $gray600,
  $moderateTextColor,
  $poorTextColor,
} from "../../cssjs/colors";
import { AirportNotifications } from "../../models/airports/AirportConfig";
import { EMPTY_STATE_MESSAGE } from "../../utils/common/Constants";
import { NoDataCard } from "../common/no-data-card/NoDataCard";

interface IAirportNotificationsCardProps {
  className?: string;
  notificationData: AirportNotifications;
  isError?: boolean;
  isMapView?: boolean;
}

const AirportNotificationsCard: React.FunctionComponent<
  IAirportNotificationsCardProps
> = ({ className, notificationData, isError = false, isMapView = false }) => {
  const classes = useStyles();
  return (
    <div
      className={mergeClasses(classes.container, className)}
      data-testid="airport-notification-card"
    >
      <header className={classes.title}>Notifications</header>
      {isError ? (
        <NoDataCard message={EMPTY_STATE_MESSAGE.Data} hideImage />
      ) : (
        <div className="d-flex">
          <div className="flex-1">
            <header className="fs-20 pb-sm-1">
              <ErrorCircleRegular
                className={mergeClasses(classes.icon, classes.criticalIcon)}
                data-testid="notification-critical-icon"
              />
              <span>{`${notificationData.critical}`}</span>
            </header>
            <footer>Critical</footer>
          </div>
          {!isMapView ? (
            <div className="flex-1">
              <header className="fs-20 pb-sm-1">
                <WarningRegular
                  className={mergeClasses(classes.icon, classes.highIcon)}
                  data-testid="notification-high-icon"
                />
                <span>{`${notificationData.high}`}</span>
              </header>
              <footer>High</footer>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default AirportNotificationsCard;

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: "8px",
    padding: "6px 12px",
  },
  title: { color: $gray600, fontWeight: 500 },
  icon: {
    fontSize: "18px",
    strokeWidth: "0.5px",
    verticalAlign: "bottom",
    paddingRight: "4px",
  },
  criticalIcon: {
    color: $poorTextColor,
    stroke: $poorTextColor,
  },
  highIcon: {
    color: $moderateTextColor,
    stroke: $moderateTextColor,
  },
});
